import { odinMetadata } from '../../data/a-feast-for-odin';
import { ODIN_GAME_ID, OdinGameListing } from './types';

export { ODIN_GAME_ID };

export const odinGameListing: OdinGameListing = {
  id: ODIN_GAME_ID,
  title: odinMetadata.title,
  subtitle: 'Podstawa + Norwegowie · 1–4 graczy',
  icon: '🛡️',
  players: '1–4 graczy',
  playTime: '90–180 min',
  contentStatus: 'partial',
  logoAccessibilityLabel: 'Logo gry Uczta dla Odyna',
  shortTitle: 'Uczta dla Odyna',
};

export const FIRST_GAME_RECOMMENDATION =
  'Rekomendowana pierwsza partia: 3 graczy, z dodatkiem Norwegowie.';

export const MODULE_NORWEGIANS_LABEL =
  'Opcjonalny dodatek — można włączyć lub wyłączyć dla 1–4 graczy.';
export const MODULE_SOLO_LABEL = 'Solo aktywne automatycznie';
